(function () {
  'use strict';

  var LABELS = {
    location: {
      office:   { variant: 'Your Office',           label: 'Office',   val: 'your office',           short: 'your office' },
      outdoors: { variant: 'Outdoors',              label: 'Outdoors', val: 'outdoor setting',       short: 'an outdoor setting' },
      home:     { variant: 'Residential',           label: 'Home',     val: 'residential',           short: 'a residential setting' },
      studio:   { variant: "Photographer's Studio", label: 'Studio',   val: "photographer's studio", short: 'the studio' }
    },
    backdrop: {
      white:    { variant: 'White',                  label: 'White',    val: 'white backdrop',        short: 'a white backdrop',    base: 264.98 },
      colour:   { variant: null,                     label: 'Colour',                short: 'a colour backdrop',   base: 304.98 },
      concrete: { variant: 'Concrete',               label: 'Concrete', val: 'concrete backdrop',     short: 'a concrete backdrop', base: 314.98 },
      blurred:  { variant: 'Blurred',                label: 'Blurred',  val: 'no backdrop, blurred',  short: 'your office, blurred',   base: 226.98 },
      infocus:  { variant: 'In Focus',               label: 'In Focus', val: 'no backdrop, in focus', short: 'your office, in focus', base: 236.98 }
    },
    lighting: {
      basic:     { variant: 'Colour (Basic Lighting)',     label: 'Basic',     ltKey: 'Basic Lighting' },
      gradient:  { variant: 'Colour (Gradient Lighting)',  label: 'Gradient',  ltKey: 'Gradient Lighting' },
      executive: { variant: 'Colour (Executive Lighting)', label: 'Executive', ltKey: 'Executive Lighting' },
      innovator: { variant: 'Colour (Innovator Lighting)', label: 'Innovator', ltKey: 'Innovator Lighting' },
      signature: { variant: 'Colour (Signature Lighting)', label: 'Signature', ltKey: 'Signature Lighting' },
      neon:      { variant: 'Colour (Neon Lighting)',      label: 'Neon',      ltKey: 'Neon Lighting' }
    },
    images: {
      1: { variant: 'One',   label: 'One',   short: 'one edited image' },
      2: { variant: 'Two',   label: 'Two',   short: 'two edited images' },
      3: { variant: 'Three', label: 'Three', short: 'three edited images' },
      4: { variant: 'Four',  label: 'Four',  short: 'four edited images' },
      5: { variant: 'Five',  label: 'Five',  short: 'five edited images' }
    }
  };

  var LOC_ORDER  = ['office', 'outdoors', 'home', 'studio'];
  var BD_ORDER   = ['white', 'colour', 'concrete', 'blurred', 'infocus'];
  var LT_ORDER   = ['basic', 'gradient', 'executive', 'innovator', 'signature', 'neon'];

  var IMAGE_ORDER = [1, 2, 3];
  function buildImageOrder(values) {
    if (!values || !values.length) return [1, 2, 3];
    var keys = Object.keys(LABELS.images);
    var order = [];
    for (var i = 0; i < values.length; i++) {
      var val = String(values[i]).trim();
      for (var j = 0; j < keys.length; j++) {
        var k = keys[j];
        if (LABELS.images[k].variant === val) { order.push(parseInt(k, 10)); break; }
      }
    }
    return order.length ? order : [1, 2, 3];
  }

  var COPY = {
    teamHint:    'Type your headcount; the group discount follows.',
    colourHint:  'Pick from the <a href="/pages/backdrops" target="_blank" rel="noopener">100+ colour catalogue</a>',
    colourLocked:'it carries into the cart with your booking',
    colourError: 'You must select your backdrop colour.',
    rateLive:    'Rate sheet',
    ppDiscounted:'Per person, after discount',
    beginsAtTwo: 'applies at two or more people',
    galleryHref: '/pages/backdrops'
  };

  var SVG = {
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>'
  };

  var CATALOGUE = (window.BK_CATALOGUE && window.BK_CATALOGUE.length) ? window.BK_CATALOGUE : [
    { code: 'A1', name: 'White', hex: '#ffffff' },
    { code: 'A4', name: 'Lunar Gray', hex: '#929598' },
    { code: 'B5', name: 'Fashion Grey', hex: '#909294' },
    { code: 'B6', name: 'Charcoal', hex: '#646b6b' },
    { code: 'A37', name: 'Royal Blue', hex: '#2b50a0' },
    { code: 'A43', name: 'Deep Blue', hex: '#1f3f6b' },
    { code: 'B55', name: 'Teal', hex: '#2e7d7a' },
    { code: 'A51', name: 'Deep Green', hex: '#1e5f3f' },
    { code: 'A29', name: 'Plum', hex: '#9f405b' },
    { code: 'B38', name: 'Ruby', hex: '#aa0114' },
    { code: 'A24', name: 'Spice', hex: '#8b4513' },
    { code: 'B15', name: 'Soft Yellow', hex: '#fff8dc' }
  ];
  function findCat(code) {
    for (var i = 0; i < CATALOGUE.length; i++) if (CATALOGUE[i].code === code) return CATALOGUE[i];
    return CATALOGUE[0];
  }

  var state = {
    location: 'office',
    backdrop: 'white',
    lighting: 'basic',
    images: 1,
    people: 1,
    colour: null,
    colourLocked: false,
    buyError: false,
    notice: null,
    peopleTouched: false
  };

  function isAvail(location, backdrop) {
    if (location === 'outdoors') return backdrop === 'blurred' || backdrop === 'infocus';
    if (location === 'studio') return backdrop !== 'blurred' && backdrop !== 'infocus';
    return true;
  }
  function isColour(backdrop) { return backdrop === 'colour'; }

  function disc() { return window.BP_DISCOUNT || null; }
  function tierPct(people) {
    var d = disc();
    if (!d || people < 2) return 0;
    return d.findTierPct(people) || 0;
  }
  function money(n) {
    var d = disc();
    if (d && d.moneyFmt) return d.moneyFmt(n);
    return '$' + Number(n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function nextBracket(people) {
    var d = disc();
    if (!d || !d.tiers) return null;
    var sorted = d.tiers.slice().sort(function (a, b) { return a.minQty - b.minQty; });
    for (var i = 0; i < sorted.length; i++) if (sorted[i].minQty > people) return { min: sorted[i].minQty, pct: sorted[i].percentage };
    return null;
  }

  function variantPriceD(s) {
    var v = resolveVariant(s);
    return (v && v.price != null) ? v.price / 100 : null;
  }
  function cheapestColourBase(s) {
    var best = null;
    for (var i = 0; i < LT_ORDER.length; i++) {
      var v = resolveVariant(Object.assign({}, s, { backdrop: 'colour', lighting: LT_ORDER[i], images: IMAGE_ORDER[0] }));
      if (v && v.price != null) { var p = v.price / 100; if (best == null || p < best) best = p; }
    }
    return best;
  }
  function discountedPricing(pp, base, pct, qty) {
    var discPerUnit = Math.round(base * (pct / 100) * 100) / 100;
    var ppAfter = Math.round((pp - discPerUnit) * 100) / 100;
    var origTotal = Math.round(pp * qty * 100) / 100;
    var totalDisc = Math.round(discPerUnit * qty * 100) / 100;
    var total = Math.round((origTotal - totalDisc) * 100) / 100;
    return { discPerUnit: discPerUnit, ppAfter: ppAfter, total: total, totalDisc: totalDisc };
  }
  function ratePricing(pp, imageCount, qty, addCost, pct) {
    var extraImages = (Number(imageCount) || 1) - 1;
    var base = pp - extraImages * addCost;
    var dp = discountedPricing(pp, base, pct, qty);
    return { base: base, discPerUnit: dp.discPerUnit, ppAfter: dp.ppAfter, total: dp.total, totalDisc: dp.totalDisc };
  }

  function calc(s) {
    var d = disc();
    var addCost = d ? d.additionalImageCost : 54.98;
    var floor = d ? d.floorPrice : 226.98;
    var imageCount = Number(s.images) || 1;
    var pp = variantPriceD(s);
    if (pp == null) {
      var cb = isColour(s.backdrop) ? cheapestColourBase(s) : null;
      var fbBase = (cb != null) ? cb : LABELS.backdrop[s.backdrop].base;
      pp = Math.max(floor, fbBase + (imageCount - 1) * addCost);
    }
    var pct = tierPct(s.people);
    var rp = ratePricing(pp, imageCount, s.people, addCost, pct);
    var add = Math.round((pp - rp.base) * 100) / 100;
    return { base: rp.base, add: add, pp: pp, pct: pct, ppAfter: rp.ppAfter, total: rp.total, totalDisc: rp.totalDisc };
  }

  var variants = [];
  var optionIndex = { location: 0, backdrop: 1, images: 2 };

  function backdropVariantValue(s) {
    return isColour(s.backdrop) ? LABELS.lighting[s.lighting].variant : LABELS.backdrop[s.backdrop].variant;
  }
  function resolveVariant(s) {
    var want = {};
    want[optionIndex.location] = LABELS.location[s.location].variant;
    want[optionIndex.backdrop] = backdropVariantValue(s);
    want[optionIndex.images]   = LABELS.images[s.images].variant;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [v.option1, v.option2, v.option3];
      if (opts[0] === want[0] && opts[1] === want[1] && opts[2] === want[2]) return v;
    }
    return null;
  }

  function configString(s) {
    var b = LABELS.backdrop[s.backdrop].label;
    if (isColour(s.backdrop)) {
      b = 'Colour · ' + LABELS.lighting[s.lighting].label;
      if (s.colourLocked && s.colour) { var c = findCat(s.colour); b += ' · ' + c.code + ' - ' + c.name; }
    }
    var im = LABELS.images[s.images];
    return LABELS.location[s.location].label + ' · ' + b + ' · ' +
      im.label + ' edited ' + (Number(s.images) === 1 ? 'image' : 'images');
  }

  function pills(k, order, map, cur, small) {
    return '<div class="bh-pills' + (small ? ' bh-pills--sm' : '') + '" role="radiogroup">' +
      order.map(function (id) {
        var on = String(id) === String(cur);
        return '<button type="button" class="bh-pill' + (on ? ' is-on' : '') +
          '" data-action="set" data-k="' + k + '" data-v="' + id + '" role="radio" aria-checked="' + on + '">' +
          map[id].label + '</button>';
      }).join('') + '</div>';
  }

  function peopleField(s) {
    var on = s.people >= 2;
    var nb = nextBracket(s.people);
    var chip = on
      ? '<i>' + SVG.check + '</i><b class="bh-red">−' + tierPct(s.people) + '%</b> group discount applied'
      : 'Group discounts apply at two or more people.';
    return '<div class="bh-people">' +
      '<div class="bh-people__io">' +
        '<button type="button" class="bh-people__btn" data-action="people-dec" aria-label="Fewer people">' + SVG.minus + '</button>' +
        '<input class="bh-people__input" type="text" data-bk-people inputmode="numeric" pattern="[0-9]*" maxlength="3" value="' + s.people + '" aria-label="Number of people">' +
        '<button type="button" class="bh-people__btn" data-action="people-inc" aria-label="More people">' + SVG.plus + '</button>' +
        '<span class="bh-people__word">' + (s.people === 1 ? 'person' : 'people') + '</span>' +
      '</div>' +
      '<span class="bh-people__chip' + (on ? ' is-on' : '') + '">' + chip + '</span>' +
    '</div>';
  }

  var BK_SPINNER_SVG = '<svg class="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#000" viewBox="0 0 256 256"><path d="M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z"/></svg>';
  function stage(s) {
    return '<div class="bh-stA">' +
      '<div class="bh-stA__frame" data-bk-frame>' +
        '<span class="bh-stA__live"><i></i> Live preview</span>' +
        '<img class="bh-stA__img" data-bk-media alt="" hidden>' +
        '<img class="bh-stA__cut" data-bk-cut alt="" hidden>' +
        '<div class="bh-stA__loading" aria-live="polite">' + BK_SPINNER_SVG + '<span>Loading…</span></div>' +
      '</div>' +
      '<div class="bh-stA__cap" data-bk-config>' + configString(s) + '</div>' +
    '</div>';
  }

  function steps(s) {
    var bdOpts = BD_ORDER.filter(function (id) { return isAvail(s.location, id); });
    var bdMap = LABELS.backdrop;
    var bdPills = '<div class="bh-pills bh-pills--sm" role="radiogroup">' + bdOpts.map(function (id) {
      var on = id === s.backdrop;
      return '<button type="button" class="bh-pill' + (on ? ' is-on' : '') +
        '" data-action="set" data-k="backdrop" data-v="' + id + '" role="radio" aria-checked="' + on + '">' + bdMap[id].label + '</button>';
    }).join('') + '</div>';
    var lightingBlock = isColour(s.backdrop)
      ? '<span class="bh-sublab">Lighting style</span>' + pills('lighting', LT_ORDER, LABELS.lighting, s.lighting, true)
      : '';
    var availNote = '';
    var realNote = ((s.backdrop === 'blurred' || s.backdrop === 'infocus') && s.location !== 'outdoors')
      ? '<span class="bh-avail">Photographed against your real surroundings; no digital backdrops.</span>'
      : '';
    var bdVal = isColour(s.backdrop) ? '<em>Colour · ' + LABELS.lighting[s.lighting].label + '</em>' : '<em>' + LABELS.backdrop[s.backdrop].val + '</em>';

    function row(n, t, body, val) {
      return '<div class="bh-step"><span class="bh-step__n">' + n + '</span>' +
        '<div class="bh-step__body"><span class="bh-step__t">' + t +
          '<span class="bh-step__t-val"> · ' + val + '</span></span>' + body + '</div>' +
        '<span class="bh-step__val">' + val + '</span></div>';
    }
    return '<div class="bh-ctlB">' +
      row('01', 'Location', pills('location', LOC_ORDER, LABELS.location, s.location, true), '<em>' + LABELS.location[s.location].val + '</em>') +
      row('02', 'Backdrop / Background', bdPills + lightingBlock + realNote + '<span class="bh-avail" data-bk-avail>' + availNote + '</span>', bdVal) +
      row('03', 'Edited images', pills('images', IMAGE_ORDER, LABELS.images, s.images, true), LABELS.images[s.images].label) +
      row('04', 'Your team', peopleField(s), s.people === 1 ? 'One' : String(s.people)) +
    '</div>';
  }

  function rateSheet(s) {
    var c = calc(s);
    var n = s.people;
    var hasQ = n >= 2;
    var qm = n + 'x';
    var qCell = function (content) { return hasQ ? '<span class="q">' + (content || '') + '</span>' : ''; };
    var imVPre = (c.add > 0 && !hasQ) ? '+ ' : '';
    var discK = hasQ ? 'Group discount · ' + n + ' people' : 'Group discount';
    var discV = hasQ ? '<b class="bh-red">−' + money(c.totalDisc) + '</b>' : COPY.beginsAtTwo;
    var imK = 'Edited images · ' + LABELS.images[s.images].label;
    return '<div class="bh-prB' + (hasQ ? ' bh-prB--q' : '') + '">' +
      '<div class="bh-prB__head"><span>' + COPY.rateLive + '</span>' + (hasQ ? '<span>Quantity</span>' : '') + '<span>CAD</span></div>' +
      '<div class="bh-prB__row bh-prB__row--base"><span class="k">Base rate · ' + LABELS.backdrop[s.backdrop].label + '</span>' + qCell(qm) + '<span class="v" data-money="base">' + money(c.base) + '</span></div>' +
      '<div class="bh-prB__row"><span class="k">' + discK + '</span>' + qCell('') + '<span class="v">' + discV + '</span></div>' +
      '<div class="bh-prB__row"><span class="k">' + imK + '</span>' + qCell(c.add > 0 ? qm : '') + '<span class="v">' + imVPre + '<span data-money="add">' + (c.add > 0 ? money(c.add) : 'included') + '</span></span></div>' +
      (c.add > 0 ? '<div class="bh-prB__row"><span class="k">Per person</span>' + qCell(qm) + '<span class="v" data-money="pp">' + money(c.pp) + '</span></div>' : '') +
      (hasQ ? '<div class="bh-prB__row bh-prB__row--sum"><span class="k">' + COPY.ppDiscounted + '</span>' + qCell(qm) + '<span class="v"><em data-money="ppAfter">' + money(c.ppAfter) + '</em></span></div>' : '') +
      '<div class="bh-prB__row bh-prB__row--total"><span class="k">' + (hasQ ? 'Team total · ' + n + ' people' : 'Total · one person') + '</span>' + qCell('') + '<span class="v"><em data-money="total">' + money(c.total) + '</em></span></div>' +
    '</div>';
  }

  function colourStep(s) {
    if (!isColour(s.backdrop)) return '';
    if (s.colourLocked && s.colour) {
      var c = findCat(s.colour);
      return '<div class="bh-colSel is-locked">' +
        '<span class="bh-colSel__lab">Backdrop colour</span>' +
        '<div class="bh-colSel__chip"><i style="--sw:' + c.hex + '"></i><b>' + c.code + ' - ' + c.name + '</b>' +
          '<span class="bh-colSel__links">' +
            '<button type="button" class="dw-link" data-action="picker-open">Change</button>' +
            '<button type="button" class="dw-link" data-action="picker-remove">Remove</button>' +
          '</span></div></div>';
    }
    var err = s.buyError && !s.colourLocked;
    return '<div class="bh-colSel' + (err ? ' is-err' : '') + '">' +
      '<span class="bh-colSel__lab">Backdrop colour</span>' +
      '<button type="button" class="bh-colSel__btn" data-action="picker-open">Select Backdrop Colour</button>' +
      (err
        ? '<span class="bh-colSel__err">' + COPY.colourError + '</span>'
        : '<span class="bh-colSel__hint">' + COPY.colourHint + '</span>') +
    '</div>';
  }

  function buyBlock(s) {
    var v = resolveVariant(s);
    var soldOut = v && v.available === false;
    var label = soldOut ? 'Unavailable' : 'Add to cart';
    return '<div class="bh-buy">' +
      '<button type="button" class="bh-buy__btn" data-action="buy"' + (soldOut ? ' disabled' : '') + '>' + label + ' <i>' + SVG.arrow + '</i></button>' +
      '<p class="bh-buy__err" data-bk-buyerr></p>' +
      '' +
    '</div>';
  }

  function instrument(s) {
    return '<div class="bhi">' +
      '<div class="bhi__stage" data-area="stage">' + stage(s) + '</div>' +
      '<div class="bhi__side">' +
        '<div data-area="controls">' + steps(s) + '</div>' +
        '<div data-area="price">' + rateSheet(s) + '</div>' +
        '<div data-area="colour">' + colourStep(s) + '</div>' +
        '<div data-area="buy">' + buyBlock(s) + '</div>' +
      '</div>' +
    '</div>';
  }

  function openPicker() {
    var bs = window.backdropSelector;
    if (!bs || typeof bs.openPicker !== 'function') return;
    var ltKey = isColour(state.backdrop) ? LABELS.lighting[state.lighting].ltKey : 'Basic Lighting';
    var current = (state.colourLocked && state.colour)
      ? (findCat(state.colour).code + ' - ' + findCat(state.colour).name)
      : null;
    bs.openPicker({
      mode: 'page',
      lighting: ltKey,
      current: current,
      onConfirm: function (colourFull) {
        state.colour = String(colourFull).split(' - ')[0];
        state.colourLocked = true;
        state.buyError = false;
        render(true);
      }
    });
  }

  var rootEl = null;
  var form = null;
  var idInput = null;
  var qtyInput = null;
  var colourInput = null;
  var formWrapper = null;

  function syncForm() {
    var v = resolveVariant(state);
    if (idInput && v) idInput.value = v.id;
    if (colourInput) colourInput.value = (state.colourLocked && state.colour) ? (findCat(state.colour).code + ' - ' + findCat(state.colour).name) : '';
    if (state.peopleTouched && qtyInput && String(qtyInput.value) !== String(state.people)) {
      qtyInput.value = String(state.people);
      qtyInput.dataset.userTouched = 'true';
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (formWrapper && v) {
      formWrapper.dataset.variantPrice = v.price;
      formWrapper.dataset.variantTitle = v.title || (v.public_title || '');
    }
    window.dispatchEvent(new CustomEvent('bk:state', { detail: { state: state, variant: v } }));
  }

  function lightingImageUrl(ltKey) {
    var bs = window.backdropSelector;
    return (bs && typeof bs.lightingImage === 'function') ? bs.lightingImage(ltKey) : '';
  }
  var lightingPreloaded = false;
  function preloadLightingImages() {
    if (lightingPreloaded) return;
    var got = 0;
    for (var i = 0; i < LT_ORDER.length; i++) {
      var url = lightingImageUrl(LABELS.lighting[LT_ORDER[i]].ltKey);
      if (url) { (new Image()).src = url; got++; }
    }
    if (got) lightingPreloaded = true;
  }
  var bkStageTimer = null;
  function bkStageLoading(img, on) {
    if (!img) return;
    var frame = img.closest('[data-bk-frame]');
    if (!frame) return;
    if (on) {
      img.style.opacity = '0';
      if (bkStageTimer) clearTimeout(bkStageTimer);
      bkStageTimer = setTimeout(function () { bkStageTimer = null; frame.setAttribute('data-loading', 'true'); }, 50);
    } else {
      if (bkStageTimer) { clearTimeout(bkStageTimer); bkStageTimer = null; }
      frame.setAttribute('data-loading', 'false');
      img.style.opacity = '1';
    }
  }
  function updateComp(resheen) {
    if (!rootEl) return;
    var frame = rootEl.querySelector('[data-bk-frame]');
    var img   = rootEl.querySelector('[data-bk-media]');
    var cut   = rootEl.querySelector('[data-bk-cut]');
    if (img && !img.__bkLoadWired) {
      img.__bkLoadWired = true;
      img.addEventListener('load', function () { bkStageLoading(img, false); });
      img.addEventListener('error', function () { bkStageLoading(img, false); });
    }
    var v = resolveVariant(state);
    var src = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
    var isGrad = LABELS.lighting[state.lighting].ltKey === 'Gradient Lighting';
    if (isColour(state.backdrop) && state.colourLocked && state.colour) {
      if (frame) { frame.style.backgroundColor = findCat(state.colour).hex; frame.classList.toggle('bh-stA__frame--gradient', isGrad); }
      var lockCut = lightingImageUrl(LABELS.lighting[state.lighting].ltKey);
      if (cut) { if (lockCut && cut.getAttribute('src') !== lockCut) cut.src = lockCut; cut.hidden = !lockCut; }
      if (img) { img.hidden = true; img.removeAttribute('src'); bkStageLoading(img, false); }
    } else if (src) {
      if (frame) { frame.style.backgroundColor = ''; frame.classList.remove('bh-stA__frame--gradient'); }
      if (cut) { cut.hidden = true; cut.removeAttribute('src'); }
      if (img) { if (img.getAttribute('src') !== src) { bkStageLoading(img, true); img.src = src; } img.hidden = false; }
    } else if (isColour(state.backdrop)) {
      if (frame) { frame.style.backgroundColor = '#cfd2d4'; frame.classList.toggle('bh-stA__frame--gradient', isGrad); }
      var nCut = lightingImageUrl(LABELS.lighting[state.lighting].ltKey);
      if (cut) { if (nCut && cut.getAttribute('src') !== nCut) cut.src = nCut; cut.hidden = !nCut; }
      if (img) { img.hidden = true; img.removeAttribute('src'); bkStageLoading(img, false); }
    } else {
      if (frame) { frame.style.backgroundColor = ''; frame.classList.remove('bh-stA__frame--gradient'); }
      if (cut) { cut.hidden = true; cut.removeAttribute('src'); }
      if (img) { img.hidden = true; img.removeAttribute('src'); bkStageLoading(img, false); }
    }
  }

  function render(resheen) {
    rootEl.querySelector('[data-area="controls"]').innerHTML = steps(state);
    rootEl.querySelector('[data-area="price"]').innerHTML = rateSheet(state);
    rootEl.querySelector('[data-area="colour"]').innerHTML = colourStep(state);
    rootEl.querySelector('[data-area="buy"]').innerHTML = buyBlock(state);
    var cfg = rootEl.querySelector('[data-bk-config]');
    if (cfg) cfg.textContent = configString(state);
    updateComp(resheen);
    syncForm();
  }

  function flashAvail() {
    var el = rootEl && rootEl.querySelector('[data-bk-avail]');
    if (!el || !el.textContent) return;
    el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash');
    setTimeout(function () { el.classList.remove('is-flash'); }, 900);
  }

  function applySet(k, v) {
    if (k === 'images') v = parseInt(v, 10);
    if (k === 'backdrop' && !isAvail(state.location, v)) { state.notice = 'blocked'; flashAvail(); return; }
    if (state[k] === v) return;
    state.notice = null;
    state[k] = v;
    if (k === 'backdrop' && !isColour(v)) { state.buyError = false; }
    if (k === 'backdrop' && isColour(v)) preloadLightingImages();
    if (k === 'location' && !isAvail(v, state.backdrop)) { state.backdrop = (v === 'outdoors') ? 'blurred' : 'white'; state.notice = 'switched'; }
    render(k === 'backdrop' || k === 'lighting' || state.notice === 'switched');
    if (state.notice === 'switched') flashAvail();
  }
  function applyPeople(n) {
    n = Math.max(1, Math.min(999, parseInt(n, 10) || 1));
    if (n === state.people) return;
    state.people = n;
    state.peopleTouched = true;
    render(false);
  }
  function requestAdd() {
    if (isColour(state.backdrop) && !state.colourLocked) { openPicker(); return; }
    submit();
  }

  function onClick(e) {
    var t = e.target.closest('[data-action]');
    if (!t || !rootEl.contains(t)) return;
    var a = t.getAttribute('data-action');

    if (a === 'set') { applySet(t.getAttribute('data-k'), t.getAttribute('data-v')); return; }
    if (a === 'people-inc') { applyPeople(state.people + 1); return; }
    if (a === 'people-dec') { applyPeople(state.people - 1); return; }
    if (a === 'picker-open') { openPicker(); return; }
    if (a === 'picker-remove') { state.colourLocked = false; state.colour = null; render(false); return; }
    if (a === 'buy') {
      if (isColour(state.backdrop) && !state.colourLocked) {
        state.buyError = true; render(false);
        var errEl = rootEl.querySelector('.bh-colSel__err, .bh-colSel');
        if (errEl) { errEl.classList.remove('is-flash'); void errEl.offsetWidth; errEl.classList.add('is-flash');
          setTimeout(function () { errEl.classList.remove('is-flash'); }, 900); }
        return;
      }
      state.buyError = false;
      submit();
      return;
    }
  }

  function onInput(e) {
    var p = e.target.closest('[data-bk-people]');
    if (!p) return;
    var clean = p.value.replace(/\D/g, '');
    if (clean !== p.value) p.value = clean;
    var n = parseInt(clean, 10);
    if (isNaN(n)) return;
    state.people = Math.max(1, Math.min(999, n));
    state.peopleTouched = true;
    rootEl.querySelector('[data-area="price"]').innerHTML = rateSheet(state);
    var chip = p.closest('.bh-people').querySelector('.bh-people__chip');
    if (chip) {
      var on = state.people >= 2;
      chip.classList.toggle('is-on', on);
      chip.innerHTML = on
        ? '<i>' + SVG.check + '</i><b class="bh-red">−' + tierPct(state.people) + '%</b> group discount applied'
        : 'Group discounts apply at two or more people.';
    }
    syncForm();
  }
  function onChange(e) {
    var p = e.target.closest('[data-bk-people]');
    if (!p) return;
    var n = parseInt(p.value.replace(/\D/g, ''), 10);
    if (isNaN(n) || n < 1) state.people = 1;
    state.peopleTouched = true;
    render(false);
  }

  var submitting = false;
  function submit() {
    state.peopleTouched = true;
    syncForm();
    var v = resolveVariant(state);
    if (!v || submitting) return;
    submitting = true;

    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', String(Math.max(1, Number(state.people) || 1)));
    if (state.colourLocked && state.colour) {
      var c = findCat(state.colour);
      fd.append('properties[Backdrop Colour]', c.code + ' - ' + c.name);
    }

    var drawer = document.getElementById('cart-drawer');
    var toggle = document.querySelector('[data-cart-drawer-toggle]');
    if (toggle && !/js-drawer-open-cart/.test(document.body.className)) toggle.click();
    function clearAdding() { if (drawer) drawer.classList.remove('bk-cart-adding'); }
    if (drawer) {
      drawer.classList.add('bk-cart-adding');
      document.addEventListener('theme:cart:added', clearAdding, { once: true });
      setTimeout(clearAdding, 4000);
    }

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:add',     { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:update',  { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        var t2 = document.querySelector('[data-cart-drawer-toggle]');
        if (t2 && !/js-drawer-open-cart/.test(document.body.className)) t2.click();
      })
      .catch(function (err) { console.error('[BK_MACHINE] add to cart failed:', err); clearAdding(); })
      .then(function () { submitting = false; });
  }

  function mount(opts) {
    rootEl     = opts.root;
    form       = opts.form || document.querySelector('form[action*="/cart/add"]') || null;
    idInput    = opts.idInput || (form && form.querySelector('[data-product-select], input[name="id"]'));
    qtyInput   = opts.qtyInput || document.querySelector('[data-form-wrapper] [data-quantity-field]');
    colourInput= opts.colourInput || null;
    formWrapper= opts.formWrapper || document.querySelector('[data-form-wrapper]');
    variants   = opts.variants || [];
    if (opts.optionIndex) optionIndex = opts.optionIndex;
    IMAGE_ORDER = buildImageOrder(opts.imageValues);
    if (opts.initial) Object.assign(state, opts.initial);
    if (IMAGE_ORDER.indexOf(state.images) === -1) state.images = IMAGE_ORDER[0];
    if (state.location && state.backdrop && !isAvail(state.location, state.backdrop)) {
      state.backdrop = (state.location === 'outdoors') ? 'blurred' : 'white';
    }

    rootEl.innerHTML = instrument(state);
    rootEl.addEventListener('click', onClick);
    rootEl.addEventListener('input', onInput);
    rootEl.addEventListener('change', onChange);

    updateComp(false);
    syncForm();
  }

  window.BK_MACHINE = {
    mount: mount,
    state: state,
    openPicker: openPicker,
    setOption: applySet,
    setPeople: applyPeople,
    requestAdd: requestAdd,
    calc: calc,
    configString: configString,
    money: money,
    isAvail: isAvail,
    isColour: isColour,
    resolveVariant: resolveVariant,
    findCat: findCat,
    tierPct: tierPct,
    LABELS: LABELS,
    orders: { location: LOC_ORDER, backdrop: BD_ORDER, lighting: LT_ORDER },
    imageOrder: function () { return IMAGE_ORDER; }
  };
})();
